import LeaveEvent from '@/components/requests/leave/events/LeaveEvent'

export default class CancelledEvent extends LeaveEvent {
  constructor(event) {
    super(event)
  }

  asNotice(authUser) {
    return `
        Leave request was cancelled by
        ${this.getActorName(authUser)}
        on
        ${this._createdAtText(authUser)}.
      `
  }

  asText(viewer) {
    return `
      **${this.getActorName(viewer)}**
      cancelled the request
    `
  }
}
